interface SystemInfo {
  computerName: string
  osInfo: string
}

export const getSystemInfo = (): SystemInfo => {
  const userAgent = window.navigator.userAgent
  const platform = window.navigator.platform

  // Get OS info
  let osInfo = ''
  if (userAgent.indexOf('Win') !== -1) {
    osInfo = 'Windows'
    // Check for Windows 10/11
    if (userAgent.indexOf('Windows NT 10.0') !== -1) {
      osInfo += ' 10/11'
    }
  } else if (userAgent.indexOf('Mac') !== -1) {
    osInfo = 'macOS'
    const match = userAgent.match(/Mac OS X ([0-9._]+)/)
    if (match) {
      osInfo += ` ${match[1].replace(/_/g, '.')}`
    }
  } else if (userAgent.indexOf('Linux') !== -1) {
    osInfo = 'Linux'
  } else {
    osInfo = platform || 'Unknown OS'
  }

  // Get computer name (hostname)
  // Since we can't get the actual hostname in browser, we'll create a readable device identifier
  const browserInfo = window.navigator.userAgent.replace(/[^a-zA-Z0-9]/g, '')
  const computerName = `${osInfo}-${browserInfo.substring(0, 8)}`

  return {
    computerName,
    osInfo
  }
}
